import { AnchorHTMLAttributes } from 'react'
import React from 'react'

import { useStore } from '@frame/lib/stores/useStore'
import { cn } from '@frame/lib/utils/cn'

type Props = {
  applyCobranding?: boolean
  children: React.ReactNode
} & AnchorHTMLAttributes<HTMLAnchorElement>

export function A({ applyCobranding = true, children, className, ...props }: Props) {
  const cobrandingColor = useStore((state) => state.session?.configuration.cobranding.button_color)

  return (
    <a
      {...props}
      className={cn(
        'cursor-pointer font-medium text-electric-650 hover:text-electric-700 hover:underline',
        applyCobranding && Boolean(cobrandingColor) && 'text-cobranding hover:text-cobranding hover:brightness-[.9]',
        className
      )}
    >
      {children}
    </a>
  )
}
